// package: vtv1
// file: proto/vorto/spot_market_response_from_email/spot_market_response_from_email_api.proto

var proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb = require("../../../proto/vorto/spot_market_response_from_email/spot_market_response_from_email_api_pb");
var proto_vorto_types_types_pb = require("../../../proto/vorto/types/types_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var SpotMarketResponseFromEmailService = (function () {
  function SpotMarketResponseFromEmailService() {}
  SpotMarketResponseFromEmailService.serviceName = "vtv1.SpotMarketResponseFromEmailService";
  return SpotMarketResponseFromEmailService;
}());

SpotMarketResponseFromEmailService.GetRequestDetails = {
  methodName: "GetRequestDetails",
  service: SpotMarketResponseFromEmailService,
  requestStream: false,
  responseStream: false,
  requestType: proto_vorto_types_types_pb.Empty,
  responseType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.GetSpotMarketRequestDetailsForQuoteResponse
};

SpotMarketResponseFromEmailService.GetRequestDetailsStream = {
  methodName: "GetRequestDetailsStream",
  service: SpotMarketResponseFromEmailService,
  requestStream: false,
  responseStream: true,
  requestType: proto_vorto_types_types_pb.Empty,
  responseType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.GetSpotMarketRequestDetailsForQuoteResponse
};

SpotMarketResponseFromEmailService.GetSitesToQuoteWith = {
  methodName: "GetSitesToQuoteWith",
  service: SpotMarketResponseFromEmailService,
  requestStream: false,
  responseStream: false,
  requestType: proto_vorto_types_types_pb.Empty,
  responseType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.SitesToQuoteWithResponse
};

SpotMarketResponseFromEmailService.CreateQuote = {
  methodName: "CreateQuote",
  service: SpotMarketResponseFromEmailService,
  requestStream: false,
  responseStream: false,
  requestType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.CreateQuotePayload,
  responseType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.GetSpotMarketRequestDetailsForQuoteResponse
};

SpotMarketResponseFromEmailService.GetLocationsByAddressSMR = {
  methodName: "GetLocationsByAddressSMR",
  service: SpotMarketResponseFromEmailService,
  requestStream: false,
  responseStream: false,
  requestType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.GetLocationsByAddressSMRPayload,
  responseType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.GetLocationsByAddressSMRResponse
};

SpotMarketResponseFromEmailService.GetPriceToBeat = {
  methodName: "GetPriceToBeat",
  service: SpotMarketResponseFromEmailService,
  requestStream: false,
  responseStream: false,
  requestType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.GetPriceToBeatPayload,
  responseType: proto_vorto_spot_market_response_from_email_spot_market_response_from_email_api_pb.GetPriceToBeatResponse
};

exports.SpotMarketResponseFromEmailService = SpotMarketResponseFromEmailService;

function SpotMarketResponseFromEmailServiceClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

SpotMarketResponseFromEmailServiceClient.prototype.getRequestDetails = function getRequestDetails(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SpotMarketResponseFromEmailService.GetRequestDetails, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SpotMarketResponseFromEmailServiceClient.prototype.getRequestDetailsStream = function getRequestDetailsStream(requestMessage, metadata) {
  var listeners = {
    data: [],
    end: [],
    status: []
  };
  var client = grpc.invoke(SpotMarketResponseFromEmailService.GetRequestDetailsStream, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onMessage: function (responseMessage) {
      listeners.data.forEach(function (handler) {
        handler(responseMessage);
      });
    },
    onEnd: function (status, statusMessage, trailers) {
      listeners.status.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners.end.forEach(function (handler) {
        handler({ code: status, details: statusMessage, metadata: trailers });
      });
      listeners = null;
    }
  });
  return {
    on: function (type, handler) {
      listeners[type].push(handler);
      return this;
    },
    cancel: function () {
      listeners = null;
      client.close();
    }
  };
};

SpotMarketResponseFromEmailServiceClient.prototype.getSitesToQuoteWith = function getSitesToQuoteWith(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SpotMarketResponseFromEmailService.GetSitesToQuoteWith, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SpotMarketResponseFromEmailServiceClient.prototype.createQuote = function createQuote(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SpotMarketResponseFromEmailService.CreateQuote, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SpotMarketResponseFromEmailServiceClient.prototype.getLocationsByAddressSMR = function getLocationsByAddressSMR(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SpotMarketResponseFromEmailService.GetLocationsByAddressSMR, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

SpotMarketResponseFromEmailServiceClient.prototype.getPriceToBeat = function getPriceToBeat(requestMessage, metadata, callback) {
  if (arguments.length === 2) {
    callback = arguments[1];
  }
  var client = grpc.unary(SpotMarketResponseFromEmailService.GetPriceToBeat, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (callback) {
        if (response.status !== grpc.Code.OK) {
          var err = new Error(response.statusMessage);
          err.code = response.status;
          err.metadata = response.trailers;
          callback(err, null);
        } else {
          callback(null, response.message);
        }
      }
    }
  });
  return {
    cancel: function () {
      callback = null;
      client.close();
    }
  };
};

exports.SpotMarketResponseFromEmailServiceClient = SpotMarketResponseFromEmailServiceClient;

